export default __webpack_public_path__ + "6da968f7f4562834dde2ea9b212306d5.png";